import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=f93c99dc&scoped=true"
import script from "./DataForm.vue?vue&type=script&lang=js"
export * from "./DataForm.vue?vue&type=script&lang=js"
import style0 from "./DataForm.vue?vue&type=style&index=0&id=f93c99dc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93c99dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f93c99dc')) {
      api.createRecord('f93c99dc', component.options)
    } else {
      api.reload('f93c99dc', component.options)
    }
    module.hot.accept("./DataForm.vue?vue&type=template&id=f93c99dc&scoped=true", function () {
      api.rerender('f93c99dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/purchase/supplier-shop/components/DataForm.vue"
export default component.exports